import React from 'react'
import classes from '../../styles/ACard.module.css';

const ACard = ({children}) => {
  return (
    <div className={classes.card}>{children}</div>
  )
}

export default ACard